import { useCallback } from "react";
import { useParams } from "react-router";
import {
  CustomerOrderQuery,
  gqlCustomerOrder,
  CustomerUpdateOrderMutation,
  CustomerUpdateOrderMutationVariables,
  gqlCustomerUpdateOrder,
} from "../generated/graphql";
import { useGraphqlQuery, useGraphqlMutation } from "./graphql";

export function useGetCustomerOrder() {
  const { companySlug } = useParams<{ companySlug: string }>();
  const { requestState } = useGraphqlQuery<CustomerOrderQuery>(
    gqlCustomerOrder,
    {
      variables: { slug: companySlug },
    }
  );
  return requestState;
}

export function useUpdateCustomerOrder() {
  const { companySlug } = useParams<{ companySlug: string }>();
  const mutation = useGraphqlMutation<
    CustomerUpdateOrderMutation,
    CustomerUpdateOrderMutationVariables
  >(gqlCustomerUpdateOrder);

  return useCallback(
    async (portalLocale: string) => {
      const res = await mutation({
        variables: {
          slug: companySlug,
          args: {
            portalLocale,
          },
        },
      });
      if (!res) {
        throw new Error();
      }
      return res.CustomerUpdateOrder;
    },
    [companySlug, mutation]
  );
}
